const v14023 = require("./120.js").getSymbolSize;
const vLN74 = 7;
exports.getPositions = function (p18225) {
  const vV14023 = v14023(p18225);
  return [[0, 0], [vV14023 - vLN74, 0], [0, vV14023 - vLN74]];
};